module.exports = "<a routerLink=\"/client/add\" class=\"btn btn-primary btn-block\">\n  <i class=\"fa fa-plus\"></i> New\n</a>"